module.exports = flarum.core.compat['common/dianliang/RouteToBindRoleModal'];